
export function Logo({ compact = false, light = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <img className="h-7" src={light === true ? "/img/logo/logowhite.png" : "/img/logo/logo.png"} alt="Brand Logo" />
    </div>
  );
}

export function Spinner({ label = "Memuat..." }) {
  return (
    <div className="min-h-[50vh] grid place-items-center" data-testid="loading-spinner">
      <div className="flex flex-col items-center gap-4">
        <img
          className="h-12 animate-pulse"
          src="/img/logo/logo.png"
          alt="Cariinjasa"
        />
        <div className="h-8 w-8 rounded-full border-4 border-brand-100 border-t-brand-600 animate-spin" />
        <p className="text-brand-500 font-medium animate-pulse">{label}</p>
      </div>
    </div>
  );
}

export function Alert({ kind = "error", children, testid }) {
  const map = {
    error: "bg-red-50 text-red-700 border-red-200",
    success: "bg-success-50 text-success-600 border-success-100",
    info: "bg-brand-50 text-brand-700 border-brand-100",
  };
  return (
    <div className={`rounded-2xl border px-4 py-3 text-sm font-medium ${map[kind]}`} data-testid={testid}>
      {children}
    </div>
  );
}

export function TrustBadge({ icon: Icon, children }) {
  return (
    <div className="flex items-center gap-2 text-brand-700">
      <Icon className="h-5 w-5 text-success-500" />
      <span className="font-semibold">{children}</span>
    </div>
  );
}

export function formatRupiah(n) {
  if (n == null) return "-";
  return "Rp " + Number(n).toLocaleString("id-ID");
}
